import { render, staticRenderFns } from "./FamilyData.vue?vue&type=template&id=197f6848&scoped=true&"
import script from "./FamilyData.vue?vue&type=script&lang=ts&"
export * from "./FamilyData.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyData.vue?vue&type=style&index=0&id=197f6848&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f6848",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCardText,VCardTitle,VCol,VIcon,VList,VListItem,VListItemTitle,VRow,VTab})
